import { render } from "./filtersCorporate.vue?vue&type=template&id=70c84e87"
import script from "./filtersCorporate.vue?vue&type=script&lang=ts"
export * from "./filtersCorporate.vue?vue&type=script&lang=ts"

import "./filtersCorporate.vue?vue&type=style&index=0&id=70c84e87&lang=scss"
script.render = render

export default script